// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dz27","colBig":"styles_colBig__24Hw_","colSmall":"styles_colSmall__1vjN7"};